module.exports = __webpack_public_path__ + "img/base-geocoding-3cb488b9.png";